// extracted by mini-css-extract-plugin
export default {"typer":"AElement_typer__ywZkF","typing":"AElement_typing__Noyyg"};